<template>
  <div class="livebroadcast_page">
    <!--直播内容 -->
    <div class="livebroadcast_content">
      <!-- 直播tab -->
      <div class="livebroadcast_time" id="zb_title">
        <div :style="{ width: width + 'px' }">
          <span
            v-for="(item, index) in fundsList"
            :key="index"
            :class="{ active: active == item[0].key }"
            @click="tabs(index, item)"
          >
            {{ item[0].key }}
            <div :class="{ actives: actives == item[0].key }"></div>
          </span>
        </div>
      </div>
      <!-- 直播列表 -->
      <div class="livebroadcast_list">
        <div
          class="livebroadcast_listbox"
          v-for="(item, index) in newfundsList"
          :key="index"
        >
          <div v-if="item.value == ''" class="wushuju">暂无直播</div>
          <div v-else class="contentsbd">
            <div class="livebroadcast_img">
              <img
                :src="'https://wx.gyzq.com.cn/wxfw' + item.photourl"
                alt=""
              />
            </div>
            <div class="livebroadcast_listcontent">
              <div class="listcontent_content">
                {{ item.title }}
              </div>
              <div class="listcontent_detail">
                <div class="detail_left">
                  <div class="detail_name">
                    <div class="detail_nameicon"></div>
                    <div class="detail_names">{{ item.auther }}</div>
                  </div>
                  <div class="detail_time">
                    <div class="detail_timeicon"></div>
                    <div class="detail_times">{{ item.time }}</div>
                  </div>
                </div>
                <div class="detail_right" @click="gozhibo(item)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 直播奖品 -->
    <div class="livebroadcast_footer">
      <div class="footer_title">
        8月15日-31日看直播，抽盲盒，积分，红包， 体脂秤，场场有礼~
      </div>
      <div class="footer_content">
        <div class="content_one"></div>
        <div class="content_two"></div>
        <div class="content_three"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { openService } from "@/utils/common";

import {
  pageBuryingPoint,
  eventBuryingPoint,
  DestructyBuryingPoint,
} from "@/utils/BuryingPoint";
import fetch from "@/utils/fetch";

import { showToast, pageRecord, setHtmlTitle } from "@/utils/h5";

export default {
  name: "HomePage",
  data() {
    return {
      subCode: "lcj_lottery",
      loginFlag: this.$root.loginFlag, //登陆状态
      accountNo: "",
      tabsList: [], //tab栏切换
      //数组
      nolist: [],
      newfundsList: [], //渲染的数组
      fundsList: [], //原始数组
      active: "",
      actives: "",
      width: 0, //动态设置导航天数的宽度
    };
  },

  created() {
    setHtmlTitle("直播专区");
    pageBuryingPoint("p_ytwx818lcjzbzq_01");
    // pageRecord(this.subCode); //增加页面访问记录
    this.zbList();
  },
  beforeDestroy() {
    //页面销毁前
    DestructyBuryingPoint("p_ytwx818lcjzbzq_01");
  },
  methods: {
    tabs(index, items) {
      console.log(items);
      console.log(this.newfundsList, "总数组");

      this.newfundsList = items;
      this.active = items[0].key;
      this.actives = items[0].key;
    },
    //直播列表
    zbList() {
      var that = this;
      fetch.post("lcj/config", { subCode: that.subCode }).then((res) => {
        if (res.code == 10000) {
          console.log(123, "直播");
          that.nolist = res.data;
          let arr = res.data;
          that.tabsList = arr;

          var date = [];
          for (var i = 0; i < arr.length; i++) {
            if (i > 0) {
              if (arr[i].key != arr[i - 1].key) {
                that.fundsList.push(date);
                date = [];
              }
            }
            date.push(arr[i]);
            if (i == arr.length - 1) that.fundsList.push(date);
          }
          let arrs = [];
          that.fundsList.forEach((items) => {
            items.forEach((item2) => {
              let obj = item2.value.split("&");
              (item2.photourl = obj[0]),
                (item2.title = obj[1]),
                (item2.auther = obj[2]),
                (item2.time = obj[3]),
                (item2.url = obj[4]);
            });

            items.filter((itemss) => {
              let keys = itemss.key;
              arrs.push(keys);
            });
          });
          console.log(that.fundsList, 333);
          arrs = arrs.filter((v, i, self) => {
            return self.indexOf(v) === i;
          });
          that.tabsList = arrs;

          let m = new Date().getMonth() + 1 + "月";
          let d =
            new Date().getDate() < 10
              ? "0" + new Date().getDate() + "日"
              : new Date().getDate() + "日";

          let dates = m + d;
          that.active = dates;
          that.actives = dates;

          that.fundsList.forEach((item1) => {
            if (item1[0].key == dates) that.newfundsList = item1;
          });

          this.width = this.fundsList.length * 80;
          this.$nextTick((_) => {
            let activeIndex = 0;
            this.fundsList.forEach((item, index) => {
              if (item[0].key == this.active) activeIndex = index;
            });
            document.getElementById("zb_title").scrollLeft =
              (activeIndex - 2) * 80 + 52;
          });
        } else {
          showToast({ message: res.msg, duration: 2000 });
        }
      });
    },
    //去直播间
    gozhibo(item) {
      console.log(item.url, 122);
      let url = item.url;
      let param = { webUrl: url };
      eventBuryingPoint("c_ytwxyx_01", "p_ytwx818lcjzbzqdetail_01");
      openService("BANNER", "3", "KDS_WebPageWithHead", param);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
